import {
  // API_BASE_URL,
  REQUEST_DISBURSEMENT,
  DISBURSEMENT_HISTORY,
  CASH_OUT_HISTORY,
  AUTH_TOKEN_KEY,
  GET_SELLER_CASHOUT_FEE,
  GET_DISBURSEMENT_SETTING
} from '../constants/';

import fetch from '../utils/Api';

export const doDisbursement = (payload) => ({
  type: REQUEST_DISBURSEMENT,
  payload: fetch({
    Authorization: 'Bearer ' +localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .post(`/users/disbursement/create`, payload)
  .then(res => {
    return res.data
})
})
// export const doDisbursement = (payload) => ({
//   type: REQUEST_DISBURSEMENT,
//   payload: fetch({
//     Authorization: 'Bearer ' +localStorage.getItem(AUTH_TOKEN_KEY)
//   })
//   .post(`/users/disbursement/balance-out`, payload)
//   .then(res => {
//     return res.data
// })
// })

export const disbursementHistory = (query) => ({
  type: DISBURSEMENT_HISTORY,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get('/users/disbursement', query)
  .then(response => response.data)
})

export const cashOutHistory = (query) => ({
  type: CASH_OUT_HISTORY,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get('/users/disbursement', {params: { status: "PENDING", ...query } })
  .then(response => response.data)
})

export const getSellerCashOutFee = (payload) => ({
  type: GET_SELLER_CASHOUT_FEE,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get("users/disbursement/generate-fees", { params: payload })
  .then(res => res.data)
})

export const getDisbursementSetting = () => ({
  type: GET_DISBURSEMENT_SETTING,
  payload: fetch().get("disbursement-setting")
  .then(res => res.data)
})

export const resetDisbursementSetting = () => ({
  type: "RESET_DISBURSEMENT_SETTING"
})
